import { render, staticRenderFns } from "./ScriptBuilderBar.vue?vue&type=template&id=70fd03b2&scoped=true&"
import script from "./ScriptBuilderBar.vue?vue&type=script&lang=ts&"
export * from "./ScriptBuilderBar.vue?vue&type=script&lang=ts&"
import style0 from "./ScriptBuilderBar.vue?vue&type=style&index=0&id=70fd03b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fd03b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBottomSheet,VBtn,VIcon,VRow,VSheet,VSlideYTransition,VSpacer,VTooltip})
